import SelectionFolderItem from './selection/folder_item_base';

export default class extends SelectionFolderItem {
  static targets = ['labelCount', 'labelText'];
  static values = {
    labelAll: String,
    labelNone: String,
    labelPartial: String,
  };

  render(dimension, selected, total) {
    this.inputFor(dimension).checked = selected > 0;

    if (selected === 0) {
      this.labelCountTarget.textContent = '';
      this.labelTextTarget.textContent = this.labelNoneValue;
    } else if (selected === total) {
      this.labelCountTarget.textContent = '';
      this.labelTextTarget.textContent = this.labelAllValue;
    } else {
      this.labelCountTarget.textContent = `${selected}/${total} `;
      this.labelTextTarget.textContent = this.labelPartialValue;
    }
  }
}
